<template>
  <div class="h-full flex flex-col">
    <div class="flex mb-10px flex-wrap">
      <el-input
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请输入作业名称或内容"
        v-model="jobSearchData.jobKeyword"
        clearable
      ></el-input>
      <el-select
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择作业区域"
        v-model="jobSearchData.jobActivityAreaId"
        clearable
      >
        <el-option
          v-for="item in areaList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        v-model="jobSearchData.jobActivityType"
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择作业类型"
        clearable
      >
        <el-option
          v-for="item in jobTypeList"
          :key="item.code"
          :label="item.displayName"
          :value="Number(item.code)"
        ></el-option>
      </el-select>
      <el-button class="mb-10px" size="small" type="primary" @click="handleSearch">搜索</el-button>
      <el-button class="mb-10px" size="small" @click="resetText()">重置</el-button>
      <el-button
        class="mb-10px"
        size="small"
        type="primary"
        @click="handleEventJob(null, 'create')"
        v-if="$hasAccess('create')"
        >新增</el-button
      >
      <el-button
        class="mb-10px"
        size="small"
        type="danger"
        @click="handleEventJob(null, 'batchDelete')"
        v-if="$hasAccess('delete')"
        >批量删除</el-button
      >
      <el-button
        class="mb-10px"
        size="small"
        @click="handleEventJob(null, 'batchImport')"
        v-if="$hasAccess('batchImport')"
        >导入</el-button
      >
    </div>
    <div class="flex-auto h-0px">
      <el-table
        :data="jobDataList"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        @selection-change="handleSelectionEquip"
        v-loading="jobTableLoading"
      >
        <el-table-column type="selection" :selectable="isDisabled" width="50"></el-table-column>
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column
          label="作业活动名称"
          prop="jobName"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="作业类型" prop="jobActivityType" show-overflow-tooltip width="100">
          <template slot-scope="scope">
            <span>{{ jobTypeMap(scope.row.jobActivityType) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="作业活动编号" prop="jobNo" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="作业活动区域"
          prop="jobActivityAreaText"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="作业内容" prop="jobContent" show-overflow-tooltip></el-table-column>
        <el-table-column label="活动频率" prop="jobActivityFrequency" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ JobActivityFrequencyMap(scope.row.jobActivityFrequency) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="涉及设备设施"
          prop="equipmentText"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="风险上报人"
          prop="reportName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="是否评价过" prop="isAppraiseText" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="时间" prop="creationTime" width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            {{
              scope.row.creationTime && dayjs(scope.row.creationTime).format('YYYY-MM-DD HH:mm:ss')
            }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="260">
          <template slot-scope="scope">
            <table-operate-button :key="scope.row.id" :buttons="buttonsJob(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="jobTableSizeChange"
        @current-change="jobTableCurrentChange"
        :current-page.sync="jobPageConfig.SkipCount"
        :page-size.sync="jobPageConfig.MaxResultCount"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="jobTotalCount"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>

    <job-form
      :FormData="FormData"
      @refreshList="
        formDialog = false
        getJobList()
      "
      @cancel="formDialog = false"
      v-if="formDialog"
      :formProps="formProps"
    ></job-form>

    <wiz-upload-file
      v-dialogDrag
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
      @exportResults="exportResults"
    ></wiz-upload-file>
  </div>
</template>

<script>
import { AreaApi } from '@wiz-api/area-management'
import { JobActivityListApi } from '@wiz-api/double-prevention-management'
import { wizUploadFile } from '@wiz-core/compts'
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import DownResultFile from '@/assets/js/safety/DownResultFile'
import utils from '@/components/safety/enumField/utils'
import JobForm from './JobForm'

const areaApi = new AreaApi()
const jobActivityListApi = new JobActivityListApi()

export default {
  name: 'job-table',
  mixins: [DownResultFile],
  components: {
    TableOperateButton,
    JobForm,
    wizUploadFile,
  },
  data() {
    return {
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 0, // 目前状态页面0为下载模板 1为上传模板 2为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      FormData: {
        jobName: '',
        jobActivityType: '',
        jobContent: '',
        jobNo: '',
        jobActivityAreaId: '',
        jobImplementationUnitId: '',
        equipmentId: '',
        jobActivityFrequency: '',
        riskAnalysisUnitId: '',
        remark: '',
      },
      formDialog: false,
      formProps: {
        // create 新增 update 编辑 read 详情
        pageType: 'create',
      },
      jobTypeList: [],
      JobActivityFrequencyList: [],
      areaList: [],
      // 作业活动清单
      jobDataList: [],
      jobTableLoading: false,
      jobTotalCount: 0,
      jobSearchData: {
        jobKeyword: '',
        jobActivityAreaId: undefined,
        jobActivityType: undefined,
      },
      jobPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      selectionJobData: [],
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 54px)'
    },
    jobTypeMap() {
      return (val) => {
        return (
          this.jobTypeList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    JobActivityFrequencyMap() {
      return (val) => {
        return (
          this.JobActivityFrequencyList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    buttonsJob() {
      return (val) => {
        return [
          {
            text: '编辑',
            click: () => {
              return this.handleEventJob(val, 'update')
            },
            isShow: this.$hasAccess('update'),
          },
          {
            text: '查看',
            click: () => {
              return this.handleEventJob(val, 'read')
            },
            isShow: this.$hasAccess('read'),
          },
          {
            text: '删除',
            click: () => {
              return this.handleEventJob(val, 'delete')
            },
            isShow: this.$hasAccess('delete') && val.isAppraise !== true,
          },
        ]
      }
    },
  },
  created() {
    this.getJobList()
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.JobActivityType',
        'DoublePreventionManagement.DataCategory.JobActivityFrequency',
      ],
      ['jobTypeList', 'JobActivityFrequencyList'],
      this
    )
    // 获取区域列表
    this.getAreaList()
  },
  methods: {
    // 禁用复选框 0禁用 1不禁用
    isDisabled(row) {
      if (row.isAppraise) {
        return 0
      }
      return 1
    },
    // 选中
    handleSelectionEquip(values) {
      this.selectionJobData = values.map((item) => {
        return item.id
      })
    },
    // 重置
    resetText() {
      this.jobSearchData = this.$options.data().jobSearchData
      this.handleSearch()
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    // 搜索 equip 设备设施 job 作业活动
    handleSearch() {
      this.jobPageConfig.SkipCount = 1
      this.getJobList()
    },
    // 列表操作-事件 作业活动清单
    async handleEventJob(row = null, operation) {
      let err = null
      let res = null
      switch (operation) {
        case 'create':
          this.FormData = this.$options.data().FormData
          this.initDialog(operation)
          break
        case 'delete':
          this.$confirm('是否删除该记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              ;[err, res] = await jobActivityListApi.callDelete(row.id)
              if (!err) {
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success',
                })
                this.getJobList()
              }
            })
            .catch(() => {})
          break
        case 'read':
          this.FormData = this.$options.data().FormData
          this.FormData = this.$options.data().FormData
          ;[err, res] = await jobActivityListApi.get({ id: row.id })
          if (!err) {
            this.FormData = {
              ...this.FormData,
              ...res,
            }
            this.initDialog(operation)
          }
          break
        case 'batchImport':
          this.uploadFileProps.active = 0
          this.uploadFileProps.visible = true
          break
        case 'update':
          this.FormData = this.$options.data().FormData
          ;[err, res] = await jobActivityListApi.get({ id: row.id })
          if (!err) {
            const { creationTime, ...otherData } = res
            this.FormData = {
              ...this.FormData,
              ...otherData,
            }
            this.initDialog(operation)
          }
          break
        case 'batchDelete':
          if (!this.selectionJobData || this.selectionJobData.length === 0) {
            this.$message({
              showClose: true,
              message: '请勾选要删除的记录',
              type: 'warning',
            })
            return
          }
          this.$confirm('删除后将无法恢复, 确认删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(async () => {
            ;[err, res] = await jobActivityListApi.deleteMany({
              ids: this.selectionJobData,
            })
            if (!err) {
              this.$message({
                showClose: true,
                message: '删除成功',
                type: 'success',
              })
              this.getJobList()
            }
          })
          break
        default:
          break
      }
    },
    // 下载模板
    async exportTemplate() {
      const [err, res] = await jobActivityListApi.excelTemplateDownload()
      if (!err) {
        this.downLoadExcel('作业活动清单', res)
        this.$message({
          showClose: true,
          message: '模板下载成功',
          type: 'success',
        })
      }
    },
    // 上传文件
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append('input', value)
      })
      const [err, res] = await jobActivityListApi.importFromExcelFile({
        input: formData.get('input'),
      })
      if (!err) {
        if (res.code === 1) {
          this.uploadFileProps.successCount = res.data?.numberSuccesses
          this.uploadFileProps.failureCount = res.data?.numberFailures
          // 如需兼容老样式，则resultFile字段为空或者不设置皆可
          this.uploadFileProps.resultFile = res.data?.fileId
          this.uploadFileProps.active = 2
          this.handleSearch()
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          })
        }
      }
      this.uploadFileProps.btnLoading = false
    },
    downLoadExcel(fileName = '下载文件', data) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${fileName}`
      link.click()
      window.URL.revokeObjectURL(link.href)
    },
    // 弹窗初始化操作
    initDialog(operation) {
      this.formDialog = true
      this.formProps.pageType = operation
    },
    // 页码改变
    jobTableSizeChange(MaxResultCount) {
      this.jobPageConfig.MaxResultCount = MaxResultCount
      this.getJobList()
    },
    // 页数改变
    jobTableCurrentChange(SkipCount) {
      this.jobPageConfig.SkipCount = SkipCount
      this.getJobList()
    },
    // 作业活动列表
    async getJobList() {
      this.selectionJobData = []
      const data = {
        maxResultCount: this.jobPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.jobPageConfig.SkipCount - 1) * this.jobPageConfig.MaxResultCount, // 跳过多少条
        ...this.jobSearchData,
      }
      this.jobTableLoading = true
      const [err, res] = await jobActivityListApi.pagedListQuery(data)
      if (!err) {
        this.jobDataList = res.items
        this.jobTotalCount = res.totalCount
      }
      this.jobTableLoading = false
    },
  },
}
</script>

<style></style>
